import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentImage extends IsibuteDocumentComponent {
  constructor({
    id,
    caption,
    altText,
    imagePath,
    contentBlobSignedId,
    pendingImageData,
    pendingImageFileName,
    unstyledContent,
    styling,
    ordinal,
    documentComponentType,
    displaySizeVariant,
    parentDocumentComponentId,
    firstChildDocumentComponentId,
    lastChildDocumentComponentId,
    previousDocumentComponentId,
    nextDocumentComponentId,
    isibuteDocument,
  }) {
    super({
      id,
      unstyledContent: unstyledContent ?? '\u200b',
      styling: styling ?? [{ start: 0, end: 1, types: ['none'] }],
      ordinal,
      documentComponentType,
      parentDocumentComponentId,
      firstChildDocumentComponentId,
      lastChildDocumentComponentId,
      previousDocumentComponentId,
      nextDocumentComponentId,
      isibuteDocument,
    });

    this.caption = caption && !caption.startsWith('\u200b')
      ? '\u200b' + caption
      : (caption || '\u200b');
    this.altText = altText;
    this.imagePath = imagePath;
    this.contentBlobSignedId = contentBlobSignedId || null;
    this.pendingImageData = pendingImageData || null;
    this.pendingImageFileName = pendingImageFileName || null;
    this.displaySizeVariant = displaySizeVariant;
  }

  hasPendingUpload = () => {
    return this.pendingImageData !== null;
  };

  getDisplayImageSrc = () => {
    if (this.pendingImageData) {
      return this.pendingImageData;
    }
    return this.imagePath;
  };

  asJSON = () => {
    return {
      id: this.id,
      caption: this.caption,
      altText: this.altText,
      imagePath: this.imagePath,
      contentBlobSignedId: this.contentBlobSignedId,
      pendingImageData: this.pendingImageData,
      pendingImageFileName: this.pendingImageFileName,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      displaySizeVariant: this.displaySizeVariant,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
    };
  };

  deepCopy = () => {
    return new this.constructor({
      id: this.id,
      caption: this.caption,
      altText: this.altText,
      imagePath: this.imagePath,
      contentBlobSignedId: this.contentBlobSignedId,
      pendingImageData: this.pendingImageData,
      pendingImageFileName: this.pendingImageFileName,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      displaySizeVariant: this.displaySizeVariant,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
      isibuteDocument: this.isibuteDocument,
    });
  };
};

export default IsibuteDocumentImage;
